import { createApp } from "vue";
import { createPinia } from 'pinia'
import router from "@/components/router/index.js";
import App from "@/App.vue";

const app = createApp(App);
const pinia = createPinia()
app.use(pinia);
// app.config.errorHandler = (err) => {
//   alert("Vue Error: " + err.message);
// };
router.beforeEach((to, from, next) => {
  document.title = to.meta?.title || "Kogas Driyap Consultant";
  // console.log("ROUTE:", to.path);
  next();
});
app.use(router);
app.mount("#app");
